export enum UserType {
  STAFF = 'STAFF',
  CLIENT = 'CLIENT',
}
